import React from 'react';
import AdminTemplate from '../layout/AdminTemplate';
import requireAuth from '~components/hocs/requireAuth';
import { Domain404CheckerPage } from '~features/domain-404-checker';

const META_TAGS = {
  title: '404 Checker - Prerender.io',
};
function NotFoundCheckerPage() {
  return (
    <AdminTemplate metaTags={META_TAGS}>
      <Domain404CheckerPage />
    </AdminTemplate>
  );
}

export default requireAuth(NotFoundCheckerPage);
